import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import {
  coverAddPath,
  CoverAddUrlQueryParams,
  coverListPath,
  CoverListUrlQueryParams,
  CoverListUrlSortField,
  coverPath,
  CoverUrlQueryParams
} from "./urls";
import CoverListComponent from "./views/CoverList";
import CoverCreateComponent from "./views/CoversCreate";
import CoverDetailsComponent from "./views/CoversDetails";

const CoverList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: CoverListUrlQueryParams = asSortParams(
    qs,
    CoverListUrlSortField
  );
  return <CoverListComponent params={params} />;
};
const CoverCreate: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: CoverAddUrlQueryParams = qs;
  return <CoverCreateComponent params={params} />;
};
const CoverDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: CoverUrlQueryParams = qs;
  return (
    <CoverDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};
export const CoverSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.cover)} />
      <Switch>
        <Route exact path={coverListPath} component={CoverList} />
        <Route exact path={coverAddPath} component={CoverCreate} />
        <Route path={coverPath(":id")} component={CoverDetails} />
      </Switch>
    </>
  );
};

export default CoverSection;
